import * as React from "react";
import PropTypes from 'prop-types';

const SvgCloseIconNew = props => {
  if (props.id !== "_svgcloseiconnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M31.314 10.808a1.5 1.5 0 10-2.122-2.122L20 17.88l-9.192-9.193a1.5 1.5 0 10-2.122 2.122L17.88 20l-9.193 9.192a1.5 1.5 0 102.122 2.122L20 22.12l9.192 9.193a1.5 1.5 0 102.122-2.122L22.12 20l9.193-9.192z" fill="#202020" /></svg>;
};

SvgCloseIconNew.displayName = "_svgcloseiconnew";
SvgCloseIconNew.propTypes = {
  id: PropTypes.string
};
SvgCloseIconNew.defaultProps = {
  id: ''
};
export default SvgCloseIconNew;